import React from "react";
import moment from "moment";
import {useFormikContext} from "formik";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import {Button, Grid, Typography} from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import {createStyles, makeStyles} from "@material-ui/core/styles";
import { ErrorCommon, TextFieldCommon} from "../../formikFormInputs";
import {usePolicyContext} from "./PolicyContext";
import {ContributionField} from "./FlexiPayments";
import {PaymentFrequency, PaymentStatus} from "./index";
import { DMC } from "./FlexiPayments";

const useStyles = makeStyles(() =>
        createStyles({
            heading: {
                flexShrink: 0,
                marginBottom: 0,
            },
        }),
);

type PaymentBreakdownMonthlyProps = {
    // DMC: string;
    fields: ContributionField[];
    frequency: string;
    handlePaymentSave: () => Promise<void>;
    paymentData: any[];
    saveIndexIds: number[];
    setSaveIndexIds: Function;
    year: number;
}
const PaymentBreakdownMonthly = (props: PaymentBreakdownMonthlyProps) => {
    const classes = useStyles();
    const {policy} = usePolicyContext();
    const { fields, frequency, handlePaymentSave, paymentData, saveIndexIds, setSaveIndexIds, year} = props;
    const {values, handleChange, setFieldValue, errors, touched}: any = useFormikContext();
    const panelName = `month${year}`;
    const [expanded, setExpanded] = React.useState<string>('');

    React.useEffect(() => {
        if(policy && policy.flexiPayments && policy.flexiPayments.length > 0) {
            policy.flexiPayments.map((payment:any, _:number) => {
                setFieldValue(`${DMC}.${payment.inx}.amount`, payment.amount)
                setFieldValue(`${DMC}.${payment.inx}.date`, moment(payment.date).format("YYYY-MM-DD"))
                setFieldValue(`${DMC}.${payment.inx}.paymentId`, payment.paymentId)
                setFieldValue(`${DMC}.${payment.inx}.status`, payment.status)
                setFieldValue(`${DMC}.${payment.inx}.inx`, payment.inx)
            })
        }
    }, [expanded])

     return (
            frequency === PaymentFrequency.Monthly &&
            paymentData && paymentData.length > 0 ?
                    <ExpansionPanel
                            expanded={expanded === panelName}
                            onChange={(_e, expanded) => setExpanded(expanded ? panelName : '')}
                            style={{marginBottom: '15px'}}
                    >

                        <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon/>}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                        >
                            <Typography className={classes.heading} variant="body1">Monthly Contributions</Typography>
                        </ExpansionPanelSummary>

                        <ExpansionPanelDetails>
                            <Grid item xs={12}>
                                {
                                    paymentData.map((payment: any, i) => {
                                        return (
                                                <Grid container spacing={2} key={i}>
                                                    {
                                                        fields.map((f, j) => {
                                                            const onBlurChange = (e: React.SyntheticEvent) => {
                                                                setSaveIndexIds([...saveIndexIds, payment.inx])
                                                                return handleChange(e);
                                                            };
                                                            const name = `${DMC}.${payment.inx}.${f.name}`;
                                                            f['disabled'] = payment.status != PaymentStatus.PaymentUpcoming; // Payment status not upcoming
                                                            f['disablePast'] = !(payment.status != PaymentStatus.PaymentUpcoming)
                                                            return (
                                                                    <Grid item xs={10} md={5} xl={5} key={j}
                                                                          className="mb15">
                                                                        <TextFieldCommon
                                                                                {...f}
                                                                                id={name}
                                                                                name={name}
                                                                                values={values}
                                                                                onChange={handleChange}
                                                                                onBlur={onBlurChange}
                                                                                cb={onBlurChange}
                                                                        />
                                                                        <ErrorCommon
                                                                                errors={errors}
                                                                                name={f.name}
                                                                                touched={touched}
                                                                        />
                                                                    </Grid>
                                                            );
                                                        })
                                                    }
                                                </Grid>
                                        );
                                    })
                                }
                                <Button
                                        type="submit"
                                        variant="contained"
                                        color="primary"
                                        className="ml20"
                                        size="small"
                                        onClick={() => handlePaymentSave()}
                                >
                                    Save Changes
                                </Button>
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel> :
                    <></>
    );
};

export default PaymentBreakdownMonthly;